import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';
// eslint-disable-next-line @stylistic/max-len
import { DatacenterViewCustomizationComponent } from '../shared/datacenter/view-customization/datacenter-view-customization.component';
import { DatacenterComponent } from '../shared/datacenter/datacenter.component';
import { ListFilterComponent } from '../shared/components/filter/list-filter.component';

import { qualityIssueResolver } from './resolvers/quality-issue.resolver';
import { DraftsComponent } from './components/list/drafts.component';
import { claimGuard } from './components/guards/claim.guard';
import { IssueCardComponent } from './components/card/issue-card.component';
import { ClaimListComponent } from './components/list/claim-list.component';
import { ClaimDashboardComponent } from './components/dashboard/claim-dashboard.component';
import { BatchSelectionComponent } from './components/entry/batch-selection.component';
import { QualityIssueEntryFormComponent } from './components/entry/quality-issue-entry-form.component';
import { QualityIssueConfirmationComponent } from './components/entry/quality-issue-confirmation.component';

export const routes: Routes = [
	{
		path: '',
		canActivate: [claimGuard],
		data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.QUALITY_ISSUE },
		children: [
			{
				path: 'list',
				children: [
					{
						path: '',
						component: ClaimListComponent,
						data: {
							pageName: 'Quality Issues - List',
							service: SERVICE_ANALYTICS.QUALITY_ISSUE,
							type: 'quality'
						},
					},
					{
						path: 'filter',
						component: ListFilterComponent,
						data: { pageName: 'Quality Issues - Filter', service: SERVICE_ANALYTICS.QUALITY_ISSUE }
					},
				],
			},

			{
				path: 'card/:issueid',
				component: IssueCardComponent,
				data: { pageName: 'Quality Issues - Card', service: SERVICE_ANALYTICS.QUALITY_ISSUE }
			},
			{
				path: 'datacenter',
				children: [
					{
						path: '',
						component: DatacenterComponent,
						data: {
							pageName: 'Quality Issues - Datacenter',
							service: SERVICE_ANALYTICS.QUALITY_ISSUE,
							type: 'quality',
							title: 'datacenter.quality-issues',
							exportExcelName: 'Qualities'
						},
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: {
							pageName: 'Quality Issues - Datacenter Customization',
							service: SERVICE_ANALYTICS.QUALITY_ISSUE
						},
					},
				],
			},
			{
				path: 'drafts',
				component: DraftsComponent,
				data: { pageName: 'Quality Issues - Draft List', service: SERVICE_ANALYTICS.QUALITY_ISSUE }
			},
			{
				path: 'new',
				resolve: {
					claim: qualityIssueResolver
				},
				children: [
					{
						path: 'batch-selection',
						component: BatchSelectionComponent,
						data: {
							pageName: 'Quality Issues - New Batch Selection',
							service: SERVICE_ANALYTICS.QUALITY_ISSUE
						},
					},
					{
						path: 'quality-issue-entry',
						component: QualityIssueEntryFormComponent,
						data: { pageName: 'Quality Issues - New Information', service: SERVICE_ANALYTICS.QUALITY_ISSUE }
					},
					{
						path: 'quality-issue-confirmation',
						component: QualityIssueConfirmationComponent,
						data: { pageName: 'Quality Issues - New Summary', service: SERVICE_ANALYTICS.QUALITY_ISSUE }
					}
				]
			},
			{
				path: 'edit/:claimId',
				resolve: {
					claim: qualityIssueResolver,
				},
				children: [
					{
						path: 'batch-selection',
						component: BatchSelectionComponent,
						data: {
							pageName: 'Quality Issues - Edit Batch Selection',
							service: SERVICE_ANALYTICS.QUALITY_ISSUE,
						}
					},
					{
						path: 'quality-issue-entry',
						component: QualityIssueEntryFormComponent,
						data: {
							pageName: 'Quality Issues - Edit Information',
							service: SERVICE_ANALYTICS.QUALITY_ISSUE,
						}
					},
					{
						path: 'quality-issue-confirmation',
						component: QualityIssueConfirmationComponent,
						data: { pageName: 'Quality Issues - Edit Summary', service: SERVICE_ANALYTICS.QUALITY_ISSUE }
					}
				]
			}
		]
	},
	{
		path: 'dashboard',
		component: ClaimDashboardComponent,
		data: { pageName: 'Quality Issues - Dashboard', service: SERVICE_ANALYTICS.QUALITY_ISSUE }
	}
];
